module.exports = __webpack_public_path__ + "media/images/emoticons/sweat01-522a61e9eee7f3246530d01c5915564c.gif";